export default __webpack_public_path__ + "static/media/Settings.574a3ad6.svg";